<template>
    <div style="position: relative; min-height: 449px">
        <textarea v-model.lazy="content" ref="editor" :id="$data._id" :name="name" :rows="rows" cols="cols" @change="emit" style="width: 100%; display: none">{{ value }}</textarea>
        <v-fade-transition>
            <v-overlay absolute v-show="loading">
                <v-progress-circular indeterminate size="100" width="5" />
            </v-overlay>
        </v-fade-transition>
    </div>
</template>

<script>
import api from "@/api";

let uuid = 0;
export default {
    props: {
        id: { type: String, default: null },
        name: { type: String, default: undefined },
        rows: { type: String, default: "10" },
        cols: { type: String, default: "100" },
        value: { type: String, default: "" },
    },
    data() {
        return {
            _id: this.$props.id || `ir${uuid}`,
            oEditors: [],
            content: "",
            loading: false,
        };
    },
    methods: {
        sync() {
            this.content = this.value;
        },
        async emit() {
            let dom = new DOMParser().parseFromString(this.content || "", "text/html");

            const images = Array.from(dom.getElementsByTagName("img")).filter((img) => img.src.startsWith("data"));
            if (0 < images.length) {
                this.loading = true;
                try {
                    for (const image of images) {
                        let arr = image.src.split(",");
                        const mime = arr[0].match(/:(.*?);/)[1];
                        const bstr = atob(arr[1]);
                        let n = bstr.length;
                        const u8arr = new Uint8Array(n);
                        while (n) {
                            u8arr[n - 1] = bstr.charCodeAt(n - 1);
                            n -= 1; // to make eslint happy
                        }
                        let file = new File([u8arr], "filename", { type: mime });

                        image.src = (await api.editor.postPhoto(file))?.files?.[0]?.url;
                    }
                } finally {
                    this.loading = false;
                }

                this.content = dom.body.innerHTML;
                if (this.oEditors[0]) {
                    this.oEditors[0].setRawHTMLContents(this.content);
                }
            }

            this.$emit("input", this.content);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    beforeCreate() {
        uuid += 1;
    },
    mounted() {
        const component = this;
        this.sync();

        nhn.husky.EZCreator.createInIFrame({
            oAppRef: this.oEditors,
            elPlaceHolder: this.$data._id,
            sSkinURI: "/js/smarteditor2/SmartEditor2Skin.html",
            fCreator: "createSEditor2",
            fOnAppLoad: () => {
                //기존 저장된 내용의 text 내용을 에디터상에 뿌려주고자 할때 사용
                try {
                    // this.oEditors.getById[this._id].exec("PASTE_HTML", [this.value]);
                    var contentElement = component.oEditors.getById[component.$data._id].elEditingAreaContainer.children[0].contentWindow.document.getElementsByClassName("se2_inputarea")[0];
                    if (contentElement) {
                        contentElement.addEventListener("focusout", function () {
                            component.oEditors.getById[component.$data._id].exec("UPDATE_CONTENTS_FIELD", []);

                            let event = document.createEvent("HTMLEvents");
                            event.initEvent("change", false, true);
                            component.$refs.editor.dispatchEvent(event);
                        });
                    }
                } catch (error) {
                    console.error("[SmartEditor]-fOnAppLoad");
                    console.error(error);
                }
            },
        });
    },
};
</script>
